import v1 from "../assets/videos/celebrations.webm";
import logo from "../assets/logos/RG copy 2.png";
import { cls } from "../components/Utility";
import c1 from "../assets/pictures/celebrations/c1.webp";
import c2 from "../assets/pictures/celebrations/c2.webp";
import c4 from "../assets/pictures/celebrations/c4.webp";
import c3 from "../assets/pictures/celebrations/c5.webp";
import c6 from "../assets/pictures/celebrations/c6.webp";
import c7 from "../assets/pictures/celebrations/c7.webp";
import c8 from "../assets/pictures/celebrations/c8.webp";
import c9 from "../assets/pictures/celebrations/c9.webp";
import c10 from "../assets/pictures/celebrations/c10.webp";
import c11 from "../assets/pictures/celebrations/c11.webp";

import auth1 from "../assets/pictures/home/auth1.jpg";
import { useEffect, useRef, useState } from "react";
import DesktopWa from "../components/DesktopWa";
import Call from "../components/Call";

export default function Reception() {
  const images = [c9, c10, c11];
  const [currentIndex, setCurrentIndex] = useState(0);
  const timeoutRef = useRef(null);

  const delay = 3000; // 3 seconds per slide

  const resetTimeout = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
  };

  useEffect(() => {
    resetTimeout();
    timeoutRef.current = setTimeout(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, delay);

    return () => resetTimeout();
  }, [currentIndex]);

  return (
    <>
      <video
        className="w-full xl:h-[730px] h-[600px] object-cover"
        autoPlay
        loop
        muted
      >
        <source src={v1} type="video/mp4" />
      </video>

      <p className="mt-[30px] font-[description1] text-[14px] text-center xl:pl-[380px] xl:pr-[380px] pl-[20px] pr-[20px]">
        We capture receptions with a perfect blend of elegance and energy,
        preserving every emotion from grand entries to heartfelt glances. Each
        frame reflects the joy, beauty, and celebration of the night in its
        truest form.
      </p>

      <div className="flex justify-center mb-[30px]">
        <img src={logo} className="w-[70px] h-[70px] object-contain" />
      </div>

      <div
        className={cls(
          "flex flex-col pl-[20px] pr-[20px] gap-[10px] mb-[50px]",
          "xl:flex-row xl:gap-[25px] xl:justify-center xl:pl-0 xl:pr-0"
        )}
      >
        {" "}
        <img
          src={c1}
          className="xl:w-[400px] xl:h-[500px] object-cover w-[500px] h-[500px] xl:mt-[40px] mt-0"
        />
        <img
          src={c2}
          className="xl:w-[500px] xl:h-[600px] object-cover w-[500px] h-[500px]"
        />
      </div>

      <p className="font-bold font-[Headings] text-[25px] text-center tracking-wider">
        THE DREAM NIGHTS
      </p>
      <div className="flex xl:justify-center xl:pl-0 xl:pr-0 pl-[20px] pr-[20px] mt-[40px] mb-[20px]">
        {" "}
        <img
          src={c4}
          className="xl:w-[600px] xl:h-[700px] object-cover w-[500px] h-[500px] "
        />
      </div>
      <p className="mt-[30px] mb-[40px] font-[description1] text-[14px] text-center xl:pl-[380px] xl:pr-[380px] pl-[20px] pr-[20px]">
        The dream night unfolds in sparkles and smiles, as we capture the magic
        of receptions filled with love, laughter, and light. Our lens follows
        every ravishing, heartwarming moment shared by the cutest couples under
        the stars.
      </p>

      <img
        src={c3}
        className=" object-cover w-full xl:h-[600px] h-full mb-[30px] "
      />

      <img
        src={c6}
        className=" object-cover w-full xl:h-[600px] h-full mb-[30px] "
      />

      <div
        className={cls(
          "flex flex-col gap-[10px] mt-[20px] pl-[20px] pr-[20px] mb-[40px]",
          "xl:flex xl:flex-row xl:gap-[10px] xl:mt-[40px] xl:justify-center"
        )}
      >
        <img
          src={c7}
          className={cls(
            "w-full h-[550px] object-cover",
            "xl:w-[600px] xl:h-[700px] xl:object-cover"
          )}
        />

        <img
          src={c8}
          className={cls(
            "w-full h-[550px] object-cover",
            "xl:w-[600px] xl:h-[700px] xl:object-cover"
          )}
        />
      </div>
      <div className="pl-[20px] pr-[20px] xl:pl-0 xl:pr-0 mb-[40px]">
        <div className="relative w-full xl:h-[850px] h-full overflow-hidden">
          {/* Slides */}
          <div
            className="flex transition-transform duration-1000 ease-linear h-full"
            style={{ transform: `translateX(-${currentIndex * 100}%)` }}
          >
            {images.map((img, index) => (
              <div
                key={index}
                className="w-full xl:h-[850px] h-full flex-shrink-0"
              >
                <img
                  src={img}
                  alt={`Slide ${index}`}
                  className="w-full h-full object-cover"
                />
              </div>
            ))}
          </div>

          {/* Dots */}
          <div className="absolute bottom-5 left-1/2 transform -translate-x-1/2 flex space-x-2">
            {images.map((_, idx) => (
              <div
                key={idx}
                className={`w-1 h-1 rounded-full ${
                  currentIndex === idx ? "bg-white" : "bg-gray-500"
                }`}
              />
            ))}
          </div>
        </div>
      </div>
      <div className="chat-icon">
        <DesktopWa />
      </div>
      <div className="chat-icon1">
        <Call phoneNumber="9980685056" />
      </div>
    </>
  );
}
